import {Typography} from 'antd';

const Header = () => {
    return <Typography.Title level={1}>Rolce</Typography.Title>;
};

export default Header;
